export const PARCEL_STATUS_BG_COLORS: Record<string, string> = {
  ON_DELIVERY: '#ffeb3b',
  DELIVERED_BY_RIDER: '#4caf50',
  PARTIALLY_DELIVERED_BY_RIDER: '#ff9800',
  RETURNED_BY_RIDER: '#f44336',
  DELIVERED: '#4caf50',
  RETURNED: '#9c27b0',
  PARTIALLY_DELIVERED: '#ffc107',
};

export function getParcelStatusBgColor(status: string): string | undefined {
  return PARCEL_STATUS_BG_COLORS[status];
}
